import { Box, Container, Flex, Text } from '@chakra-ui/react';
import { useTranslation } from 'react-i18next';

export const VirtualEventsHeading = () => {
  const { t } = useTranslation();

  return (
    <Box
      bgImage="radial-gradient(87.42% 234.39% at -0.8% 0%, #F563FF 0%, rgba(8, 255, 255, 0.50) 10.76%, rgba(15, 255, 231, 0.35) 30%, rgba(255, 120, 147, 0.10) 55%, rgba(0, 5, 15, 0.00) 86%), linear-gradient(90deg, #000 0.17%, #000 99.8%)"
      bgRepeat="no-repeat"
      p={6}
      pb={12}
      mt="-65px"
    >
      <Container>
        <Flex h="290px" alignItems="center">
          <Text
            as="h1"
            mt="65px"
            w={{ base: 'full', md: '80%', lg: '70%' }}
            color="white"
            fontFamily="heading"
            fontSize={{ base: '2xl', md: '3xl', lg: '4xl' }}
          >
            {t('virtualEventsPage.heading.0')}
            <Text as="span" fontWeight="bold" fontFamily="heading">
              {t('virtualEventsPage.heading.1')}
            </Text>
          </Text>
        </Flex>
      </Container>
    </Box>
  );
};
